import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

import Helper, { convertDateFormat, convertMobileFormat, convertIdCardFormat } from "../../../services/helper";

import HeaderPageTitle from "../../../layouts/inc/HeaderPageTitle";
import useTranslations from "../../../i18n/useTranslations";
import { usePageContent } from "../../../i18n/useContentMap";

import img_icoEdit from "../../../assets/img/ci/profile/ico-edit.svg";
import img_imgProfile from "../../../assets/img/ci/profile/img-profile.png";

const ProfileDetail = () => {
  const stateProfile = useSelector((state) => state.profile);
  const { t } = useTranslations();
  const content = usePageContent("profileDetail");

  /* Handle goto page */
  const navigate = useNavigate();

  const handleGotoPage = (e) => {
    e.preventDefault();
    // console.log("click GotoPage", e.currentTarget.dataset.page);

    const page = e.currentTarget.dataset.page;
    navigate("/" + page);
  };
  /* End Handle goto page */

  // Helper function for gender display
  const getGenderDisplay = (gender) => {
    switch (gender) {
      case "M":
        return t("profileDetail.genderOptions.male");
      case "F":
        return t("profileDetail.genderOptions.female");
      default:
        return t("profileDetail.genderOptions.notSpecified");
    }
  };

  /* First event render */
  useEffect(() => {
    // console.log("useEffect !", stateProfile);

    if (Object.getOwnPropertyNames(stateProfile.dataUser).length === 0) {
      navigate("/");
    }
  }, []);
  /* End First event render */

  return (
    <>
      <Helmet>
        <title>{content.title} - Paypoint</title>
        <meta name="title" content={`${content.title} - Paypoint`} />
        <meta name="description" content={content.title} />
        <meta name="keyword" content="profile, โปรไฟล์, paypoint" />
        <meta property="og:title" content={`${content.title} - Paypoint`} />
        <meta property="og:description" content={content.title} />
        <meta property="og:image" content="" />
        <meta property="og:url" content="" />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Paypoint" />
      </Helmet>

      <div id="pageProfileDetail">
        <main>
          <div className="wrapContent">
            <HeaderPageTitle title={content.title} prevPage="/profile" />

            <section id="pProfileDetail">
              <div className="bProfileDetail">
                <div className="bTitle">
                  <div className="bBtn" onClick={handleGotoPage} data-page="edit-profile">
                    <img src={img_icoEdit} alt="" />
                    <a href="#">{content.edit}</a>
                  </div>
                  <div className="user-detail">
                    <div className="bProfile-picture">
                      {/* <img className="profile" src={img_imgProfile} alt="" /> */}
                      <img className="profile" src={stateProfile.lineImgUrl} alt="" />
                    </div>
                    <p>{stateProfile.dataUser.fullname}</p>
                    <p>ID: {stateProfile.id}</p>
                  </div>
                </div>

                <div className="bForm">
                  <div className="bRow">
                    <div className="control-group">
                      <div className="tTitle">{t("profileDetail.fields.name")}</div>
                      <p>{stateProfile.dataUser.fullname}</p>
                    </div>
                  </div>
                  <div className="bRow">
                    <div className="control-group">
                      <div className="tTitle">{t("profileDetail.fields.phoneNumber")}</div>
                      <p>{convertMobileFormat(stateProfile.dataUser.mobileNo, "-")}</p>
                    </div>
                  </div>
                  <div className="bRow">
                    <div className="control-group">
                      <div className="tTitle">{t("profileDetail.fields.idCard")}</div>
                      <p>{convertIdCardFormat(stateProfile.dataUser.idCard, "-")}</p>
                    </div>
                  </div>
                  <div className="bRow">
                    <div className="control-group">
                      <div className="tTitle">{t("profileDetail.fields.email")}</div>
                      <p>{stateProfile.dataUser.email ?? ""}</p>
                    </div>
                  </div>
                  <div className="bRow">
                    <div className="control-group">
                      <div className="tTitle">{t("profileDetail.fields.birthDate")}</div>
                      <p>{convertDateFormat(stateProfile.dataUser.birthDate, "d/m/y")}</p>
                    </div>
                  </div>
                  <div className="bRow">
                    <div className="control-group">
                      <div className="tTitle">{t("profileDetail.fields.gender")}</div>
                      <p>{getGenderDisplay(stateProfile.dataUser.gender)}</p>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </main>
      </div>
    </>
  );
};

export default ProfileDetail;
